import { render, staticRenderFns } from "./FeatureBreadcrumb.vue?vue&type=template&id=316db8e6&scoped=true&"
import script from "./FeatureBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./FeatureBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316db8e6",
  null
  
)

export default component.exports